<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn" @click="initHomeworkManageTeaData()"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">课程库&gt;</div>
      </div>
      <div class="body_content">
        <div class=" col-xs-8 col-sm-8">
        <div class="lesson_top">
          <button type="button" class="btn btn-default btn_option" data-toggle="modal" data-target="#myModal">
            增加课程
          </button>
          <div class="searcharea">
            <select class="form-control" v-model="searchParams.type" placeholder="课程类型">
              <option selected value="">- 请选择类型</option>
              <option v-for="(courseType, key, index) in course_type" :value="key">{{courseType}}</option>
            </select>
            <select class="form-control" v-model="searchParams.status" placeholder="课程状态">
              <option selected value="">- 请选择状态</option>
              <option v-for="(courseType, key, index) in check_status" :value="key">{{courseType}}</option>
            </select>
            <input class="form-control" placeholder="课程名称、教师姓名"  v-model="searchParams.teacherName"/>
            <button type="button" class="btn btn-default btn_option" @click="initLessonListData()">查询</button>
          </div>
        </div>

        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content query-modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                <h4 class="modal-title" id="myModalLabel">{{option_flag=="add"?'新增':'编辑'}}课程</h4>
              </div>
              <div class="modal-body query-modal-lesson">
                <label>课程名称：</label>
                <input type="text" v-validate="'required|maxL:80'" data-vv-scope="course" data-vv-as="课程名称" name="name" class="form-control lesson_name" v-model="course.name"/>
                <span class="spanRed">*</span>
                <span class="validateTip">{{ errors.first('course.name') }}</span>


                <label class="course_type_label">课程类型：</label>
                <select class="form-control course_type" v-validate="'required|maxL:80'" data-vv-scope="course" data-vv-as="课程类型" name="type" v-model="course.type">
                  <option value="">选择课程类型</option>
                  <option v-for="(courseType, key, index) in course_type" :value="key">{{courseType}}</option>
                </select>
                <span class="spanRed">*</span>
                <span class="validateTip">{{ errors.first('course.type') }}</span>

                <label>课时：</label>
                <input type="number" v-validate="'required|maxL:80'" data-vv-scope="course" data-vv-as="课时" name="takeHours" class="form-control lesson_name" v-model="course.takeHours"/>
                <span class="spanRed">*</span>
                <span class="validateTip">{{ errors.first('course.takeHours') }}</span>

                <label>描述：</label>
                <textarea class="form-control description-textarea" placeholder="描述" rows="10" v-model="course.description" style="resize: none"></textarea>

              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default okBtn" @click="addLesson()">确定</button>
                <button type="button" class="btn btn-default okBtn" data-dismiss="modal" @click="">取消</button>
              </div>
            </div>
          </div>
        </div>

        <div class="classList_div">
          <table class="table table-striped les_tabShow lesson_tab">
            <thead>
            <tr>
              <th width="">课程名称</th>
              <th width="15%">课程类型</th>
              <th width="10%">课时</th>
              <th width="10%">状态</th>
              <th width="20%">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(lessonOne, index) in lessonList" :key="index" @click="loadCourseTeacherData(lessonOne.id)" :class="{selected:editTeacherByCourseId==lessonOne.id}">
              <td width="" class="tabTd_content_ellipsis">{{lessonOne.name}}</td>
              <td width="20%">{{lessonOne.type | formatType}}</td>
              <td width="5%">{{lessonOne.takeHours}}</td>
              <td width="5%">{{lessonOne.status | formatStatus}}</td>
              <td width="20%">

                <div class="edit_pic" @click.stop="option_flag='update';updateCourse(lessonOne)" title="修改"></div>
                <div class="delete_pic" @click.stop="deleteLessonId=lessonOne.id;deleteCourseById()" title="删除"></div>
                <div class="unpublish_pic" v-if="lessonOne.status == 1"  @click.stop="updateStatus(lessonOne)" title="取消发布"></div>
                <div class="publish_pic" v-else @click.stop="updateStatus(lessonOne)" title="发布"></div>

              </td>
            </tr>
            </tbody>
          </table>

          <page-view v-bind="searchParams"></page-view>

        </div>
        </div>
        <div class="col-xs-4 col-sm-4" v-if="editTeacherByCourseId">
          <div class="teacher_top">
            <span>授课教师</span>
            <input class="form-control" type="text" placeholder="输入授课教师" v-model="searchTeacherName" @keyup.enter="addTeacher(0)" @keyup.up="addTeacher(-1)" @keyup.down="addTeacher(1)"  @keyup="loadQueryInputDataWhenAdd($event)" @focus="loadQueryInputDataWhenAdd()" autocomplete="off">
            <button type="button" class="btn btn-default btn_option okBtn" @click="saveTeacher()">新增</button>
            <div id="teachers_div">
              <option v-for="(queryData, index) in queryInputDataArr" :key="index" :value="queryData.userName" :class="index != selectedIndex||'selected'"
                      @click="chooseTeachers(queryData.id,queryData.userName)">{{queryData.userName}}-{{queryData.mobile}}</option>
            </div>

          </div>
          <div class="classList_div">
            <table class="table table-striped les_tabShow lesson_tab">
              <thead>
              <tr>
                <th width="40%">教师姓名</th>
                <th width="20%">状态</th>
                <th width="40%">操作</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(ct, index) in courseTeacherList" :key="index">
                <td width="40%" class="tabTd_content_ellipsis">{{ct.teacherName}}</td>
                <td width="20%">{{ct.status | formatTeacherStatus}}</td>
                <td width="40%">
                  <button type="button" v-if="ct.status == 1" class="btn btn-default cancel_lesson" @click="updateTeacherStatus(ct.id,ct.status)">停课</button>
                  <button type="button" v-else class="btn btn-default btn_option report_lesson " @click="updateTeacherStatus(ct.id,ct.status)">开课</button>
                  <button type="button" class="btn btn-default delete_lesson" @click="deleteTeacherById(ct.id)">删除</button>

                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";

  import {getContentSize} from './mainView';
  import dictionaryData from '../json/dictionary';
  import pageView from './pageView';

  export default {
    name: "courseManageTea",
    components:{pageView},
    data() {
      return {
        //课程列表
        lessonList: [],

        token: this.$store.state.access_token,

        //课程
        course: {
          description: "",
          id: "",
          name: "",
          reportTime: null,
          status: "0",
          takeHours: 4,
          type: "1"
        },
        searchTeacherName:"",
        queryInputDataArr:[],
        selectedIndex: -1,
        searchTeacherNameComplete: false,
        teacherId:"",
        teacherName:"",
        searchParams: {
          teacherName:'',
          status:"",
          type:"",
          all: 0,
          rows: 10,
          page:1
        },

        deleteLessonId: '',
        //课程类型
        course_type: dictionaryData.course_type,
        check_status: dictionaryData.check_status,
        //当前选中课程类型
        activeType:'',
        option_flag:"add",
        editTeacherByCourseId:"",
        courseTeacherList:[]
      }
    },
    filters: {
      formatType(value){
        let this_ = this;
        if(dictionaryData.course_type && value){
          value = dictionaryData.course_type[value];
        }
        return value;
      },
      formatStatus(value){
        let this_ = this;
        if(dictionaryData.check_status && value){
          value = dictionaryData.check_status[value];
        }
        return value;
      },
      formatTeacherStatus(value){
        let this_ = this;
        if(dictionaryData.course_teacher_status && value){
          value = dictionaryData.course_teacher_status[value];
        }
        return value;
      }
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        this_.closeModal();
        this_.initLessonListData();
        this_.searchParams.page = 1;
        this_.searchParams.pageCallback = this_.initLessonListData;
      });
    },
    methods: {
      /**
       * 初始加载数据
       */
      initLessonListData(pageParams){
        let this_ = this;
        this_.editTeacherByCourseId='';

        if(pageParams)
          Object.assign(this_.searchParams, pageParams);

        let _searchParams = {};
        Object.assign(_searchParams, this_.searchParams);
        delete _searchParams.pageCallback;//提交前删除回调
        schoolAxios({
          method: 'get',
          url: 'course/pageList',
          params: _searchParams
        }).then(function (resp) {
          //课程记录
          let lessonData = resp.data;
          if(lessonData.success){
            this_.lessonList = lessonData.list;
            this_.searchParams.all = lessonData.totalPage;
            this_.searchParams.page = 1;
          }
        })
      },
      /**
       * 初始加载数据
       */
      loadCourseTeacherData(id){
        let this_ = this;
        this_.editTeacherByCourseId = id;

        schoolAxios({
          method: 'get',
          url: 'course/getTeachers',
          params: {
            id: id
          }
        }).then(function (resp) {
          //课程记录
          let data = resp.data;
          if(data.success){
            this_.courseTeacherList = data.list;
          }
        })
      },
      /**
       * 新增课程
       */
      addLesson(){
        let this_ = this;
        this_.$validator.validateAll('course').then(result => {
          if (result) {
            schoolAxios({
              method: 'post',
              url: 'course/' + this_.option_flag,
              data: this_.course
            }).then(function (resp) {
              let data = resp.data;
              if(data.success){
                $("#myModal").modal("hide");
                // "保存成功".showMessage();
                this_.initLessonListData();
              }else{
                "保存失败".showMessage();
              }
            })
          }
        });
      },
      updateCourse(course){
        Object.assign(this.course, course);
        this.option_flag="edit";
        $("#myModal").modal("show");
      },
      updateStatus(course){
        let this_ = this;
        let status = course.status;
        (status == '1'?"确定要取消发布课程吗？":"确定要发布课程吗？").showConfirm(function () {
          if(status == '1') status = '0';
          else status = '1';
          schoolAxios({
            method: 'put',
            url: 'course/updateStatusById',
            data: {
              id: course.id,
              status: status,
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              this_.initLessonListData();
            }
          });
        });
      },
      /**
       * 删除课程
       */
      deleteCourseById(){
        let this_=this;
        "确定删除课程吗？".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'course/delete/' + this_.deleteLessonId,
            params: {}
          }).then(function (response) {
            this_.initLessonListData();
          });
        })
      },
       /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $('#myModal').on('hide.bs.modal', function () {
          //课程
          this_.course = {
            description: "",
            id: "",
            name: "",
            reportTime: null,
            status: "0",
            takeHours: 4,
            type: "1"
          };
          this_.option_flag = "add";
          setTimeout(function () {
            this_.errors.clear('course');
          });

        });
      },
      addTeacher(opt){
        let this_ = this;
        if(opt == 0){
          if(this_.searchTeacherName){
            if(this_.selectedIndex >= 0 && this_.queryInputDataArr && this_.selectedIndex < this_.queryInputDataArr.length) {
              let d = this_.queryInputDataArr[this_.selectedIndex];
              this_.selectedIndex = -1;
              this_.chooseTeachers(d.id, d.userName);
              $("#teachers_div").hide();
            }
          }
        }

        if(this_.queryInputDataArr && this_.queryInputDataArr.length>0){
          if(opt == -1){
            if(this_.selectedIndex <= 0) return;
            else this_.selectedIndex -= 1;
          }else if(opt == 1){
            if(this_.selectedIndex == this_.queryInputDataArr.length-1) return;
            else this_.selectedIndex += 1;
          }
          this_.searchTeacherName = this_.queryInputDataArr[this_.selectedIndex].userName;
        }
      },
      teacherReset(){
        let this_ = this;
        this_.searchTeacherNameComplete = false;
        this_.searchTeacherName = "";
        this_.selectedIndex = -1;
        this_.teacherId = "";
        this_.teacherName = "";
      },
      /**
       * 联想查询班主任信息-add
       */
      loadQueryInputDataWhenAdd(event){
        let this_ = this;

        if(event && (event.keyCode == 13 //回车
          ||event.keyCode == 38//上键
          ||event.keyCode == 40 ))//下键
          return;
        if(this_.searchTeacherNameComplete && event && (event.keyCode == 8 || event.keyCode == 48 )){//选择后删除
          this_.teacherReset();
          return;
        }
        if (this_.searchTeacherName != "") {

          //后台查询数据赋值
          schoolAxios({
            method: 'get',
            url: 'user/queryUserSchoolByUserName',
            params: {
              'userName': this_.searchTeacherName
            }
          }).then(function (resp) {
            let data = resp.data;
            if (data.success) {
              this_.queryInputDataArr = data.list;
              $("#teachers_div").show();
            }
          });
        } else {
          this_.queryInputDataArr = [];
          $("#teachers_div").hide();
          this_.selectedIndex = -1;
          this_.teacherId = "";
          this_.teacherName = "";
        }
      },
      saveTeacher(){
        let this_ = this;
        if(!this_.teacherId || !this_.teacherName){
          "请选择教师".showMessage();
          return;
        }
        if(!this_.editTeacherByCourseId){
          "请选择课程".showMessage();
          return;
        }
        schoolAxios({
          method: 'post',
          url: 'course/addTeacher',
          data: {
            teacherId: this_.teacherId,
            teacherName: this_.teacherName,
            courseId: this_.editTeacherByCourseId
          }
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            $("#myModal").modal("hide");
            this_.loadCourseTeacherData(this_.editTeacherByCourseId);
            this_.teacherReset();
          }else{
            "保存失败".showMessage();
          }
        })
      },
      deleteTeacherById(id){
        let this_=this;
        "确定删除课程吗？".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'course/deleteTeacher',
            params: {
              id:id
            }
          }).then(function (response) {
            this_.loadCourseTeacherData(this_.editTeacherByCourseId);
          });
        })
      },
      /**
       * 更新报课状态
       */
      updateTeacherStatus(id, status){
        let this_ = this;
        (status == '1'?"确定要停课吗？":"确定要开课吗？").showConfirm(function () {
          if(status == '1') status = '0';
          else status = '1';
            schoolAxios({
              method: 'put',
              url: 'course/updateTeacherStatus',
              data: {
                id: id,
                status: status,
              }
            }).then(function (resp) {
              let data = resp.data;
              if(data.success){
                this_.loadCourseTeacherData(this_.editTeacherByCourseId);
              }
            });
          });
      },
      chooseTeachers(id,teacherName){
        let this_ = this;
        this_.teacherId = id;
        this_.teacherName = teacherName;
        this_.searchTeacherName = teacherName;
        $("#teachers_div").hide();
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .classList_div {
    position: relative;
    top: 2%;
    width: 100%;
    height: 86%;
    overflow: auto;
  }
  .les_tabShow {
    margin: 0 0 0 0;
    width: 100%;
    max-height: 100%;
    /* table-layout: fixed;*/
  }
  .les_tabShow tr {
    /*border-bottom: 1px grey solid;*/
    height: 50px;
  }
  .les_tabShow tr td{
    border: 0px;
    line-height: 32px;
  }
  .tabTd_content_ellipsis {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    -moz-text-overflow: ellipsis;
  }
  .lesson_tab tr th {
    background-color: #cccccc;
    color: black;
    font-size: 16px;
    text-align: center;
    line-height: 30px;
  }
  .lesson_tab tr td {
    text-align: center;
    font-size: 16px;
  }
  .lesson_tab tbody {
    /*height: 600px;*/
    font-weight: bold;
  }
  /*.course_type_btn:active{
    background-color:gray;
  }*/
  .havenClick {
    background-color: #ff6f66;
  }
  .report_lesson,.delete_lesson {
    width: 50px;
    height: 30px;
    border-radius: 20px;
    line-height: 15px;
    font-size: 15px;
    font-weight: bold;
  }
  .cancel_lesson {
    height: 30px;
    border-radius: 20px;
    line-height: 10px;
    font-size: 15px;
    font-weight: bold;
  }
  button.btn.btn-default.cancel_lesson {
    width: 50px;
  }
  button.btn.btn-default.report_lesson {
    width: 50px;
  }
  button.btn.btn-default.delete_lesson {
    width: 50px;
  }
  /*.query-modal-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 100%);
    width: 400px;
    height: 360px;
  }*/
  .modal-body.query-modal-lesson {
    /*height: 220px;*/
  }
  .query-modal-lesson label {
    margin: 10px 0 0 0;
  }
  .query-modal-lesson input {
    width: 95%;
  }
  #teachers_div {
    position: absolute;
    left: 120px;
    width: 200px;
    border: 1px grey solid;
    background-color: white;
    display: none;
  }
  #teachers_div option {
    height: 30px;
    line-height: 30px;
  }
  #teachers_div option:hover {
    background-color: grey;
  }
  .btn-default {
    width: 140px;
    height: 30px;
    border-radius: 5px;
  }
  .okBtn {
    width: 50px;
    line-height: 0px;
  }
  .lesson_top {
    margin: 20px 0;
  }
  .lesson_name {
    display: unset;
  }

  .teacher_top{
    margin: 20px 0;
  }
  .teacher_top span{
    display: inline-block;
    margin: 0 20px;
  }
  .teacher_top .form-control{
    display: inline-block;
    width: 40%;
  }
  .teacher_top button{
    width: 80px;
  }
  .course_type_div {
    margin: 0px 0 0 75px;
    float: right;
  }
  .course_type_btn {
    width: 80px;
    height: 25px;
    border-radius: 20px;
    margin: 2px 6px;
    line-height: 10px;
  }
  .course_type {
    display: unset;
  }
  /*.course_type_choose {
    width: 80px;
    float: left;
    text-align: center;
    border: 1px solid darkgray;
    border-radius: 20px;
    margin: 2px 6px;
  }*/


  .query-modal-lesson select {
    width: 95%;
    margin: 5px 0 0 3px;
  }
  .searcharea{
    width: 80%;
    float: right;
    text-align: right;
  }
  .searcharea .form-control{
    display: inline-block;
    width: 160px;
  }
  .searcharea button{
    width: 60px;
  }
  .edit_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/edit.png");
    background-size: 100% 100%;
    float: left;
  }
  .delete_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/delete.png");
    background-size: 100% 100%;
    float: left;
  }
  .publish_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/publish.png");
    background-size: 100% 100%;
    float: left;
  }
  .unpublish_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/unpublish.png");
    background-size: 100% 100%;
    float: left;
  }
  .edit_pic,.delete_pic, .publish_pic, .unpublish_pic{
    margin: 0 2% ;
    cursor: pointer;
  }
  #teachers_div {
    position: absolute;
    left: 26px;
    width: 84%;
    border: 1px grey solid;
    background-color: white;
    display: none;
    z-index: 1000;
  }
  #teachers_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  #teachers_div option:hover , #teachers_div .selected, .lesson_tab tr.selected{
    background-color: grey!important;
  }

</style>



// WEBPACK FOOTER //
// src/components/courseManage.vue